import React from 'react'
import styled from 'styled-components'
import Section from './Section'
import Zoom from 'react-reveal/Zoom';

function Home() {
  return (
    <Container>
      <Zoom>
        <Section carname='MODEL S' src='model-s.jpg' description='Order Online For Touchless Deliver' lb='Custom Order' rb='Existing Inventory' />
      </Zoom>

      <Section carname='MODEL X' src='model-x.jpg' description='Order Online For Touchless Deliver' lb='Custom Order' rb='Existing Inventory' />


      <Section carname='MODEL Y' src='model-y.jpg' description='Order Online For Touchless Deliver' lb='Custom Order' rb='Existing Inventory' />


      <Section carname='MODEL 3' src='model-3.jpg' description='Order Online For Touchless Deliver' lb='Custom Order' rb='Existing Inventory' />


      <Section carname='SOLAR PANEL' src='solar-panel.jpg' description='Money-back gurantee' lb='Order now' rb='Learn more' />


      <Section carname='SOLAR ROOF' src='solar-roof.jpg' description='Produce Clean Energy From Your Roof' lb='Order now' rb='Learn More' />


      <Section carname='Accessories' src='accessories.jpg' description='' lb='Shop Now' />


    </Container>
  )
}

export default Home

const Container = styled.div`
height:100vh`